import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AcademicState } from './academic.state';

export const featureKey = 'academic';

export const academicFeature = createFeatureSelector<AcademicState>(featureKey);

export const state = createSelector(academicFeature, (state: AcademicState) => state);
export const groupActive = createSelector(academicFeature, ({ group_active }: AcademicState) => group_active);
